<div class="order-history">
  <!-- Header -->
  <div class="history-header">
    <button class="back-btn" (click)="goBack()">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
    </button>
    <h1>Mi Actividad</h1>
    <button class="refresh-btn" (click)="activeTab() === 'orders' ? loadOrders() : loadReservations()"
            [disabled]="loading() || loadingReservations()">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
           [class.spinning]="loading() || loadingReservations()">
        <polyline points="23 4 23 10 17 10"/>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button class="tab" [class.tab-active]="activeTab() === 'orders'" (click)="switchTab('orders')">
      Pedidos
      @if (orders().length > 0) {
        <span class="tab-count">{{ orders().length }}</span>
      }
    </button>
    <button class="tab" [class.tab-active]="activeTab() === 'reservations'" (click)="switchTab('reservations')">
      Reservas
      @if (reservations().length > 0) {
        <span class="tab-count">{{ reservations().length }}</span>
      }
    </button>
  </div>

  <!-- ========== ORDERS TAB ========== -->
  @if (activeTab() === 'orders') {

  <!-- Loading -->
  @if (loading()) {
    <div class="loading-state">
      <div class="spinner"></div>
      <p>Cargando pedidos...</p>
    </div>
  }

  <!-- Error -->
  @if (errorMsg()) {
    <div class="error-banner">
      {{ errorMsg() }}
      <button (click)="loadOrders()">Reintentar</button>
    </div>
  }

  <!-- Empty state -->
  @if (!loading() && !errorMsg() && orders().length === 0) {
    <div class="empty-state">
      <div class="empty-icon">📦</div>
      <h3>Sin pedidos</h3>
      <p>Aun no has realizado ningun pedido</p>
    </div>
  }

  <!-- Orders list -->
  @if (!loading() && orders().length > 0) {
    <div class="orders-list">
      @for (order of orders(); track order.id) {
        <div class="order-card" [class.order-active]="isActiveOrder(order.status)"
             (click)="toggleOrderDetail(order.id)">
          <div class="order-top">
            <div class="order-business">
              <span class="service-icon">{{ getServiceIcon(order.service_type) }}</span>
              <div class="business-info">
                <span class="business-name">{{ order.business_name || 'Negocio' }}</span>
                <span class="order-date">{{ formatDate(order.ordered_at) }}</span>
              </div>
            </div>
            <div class="order-top-right">
              @if (order.order_ref) {
                <span class="order-ref-badge">{{ order.order_ref }}</span>
              }
              <span class="status-badge" [class]="getStatusClass(order.status)">
                {{ getStatusLabel(order.status) }}
              </span>
            </div>
          </div>

          <div class="order-details">
            <div class="detail-row">
              <span class="detail-label">Tipo</span>
              <span class="detail-value">{{ getServiceLabel(order.service_type) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Articulos</span>
              <span class="detail-value">{{ order.items_count }}</span>
            </div>
            <div class="detail-row total-row">
              <span class="detail-label">Total</span>
              <span class="detail-value total-amount">{{ formatPrice(order.total_amount, order.currency) }}</span>
            </div>
          </div>

          <!-- Items detail (expandable) -->
          @if (isExpanded(order.id) && order.order_items && order.order_items.length > 0) {
            <div class="order-items">
              <div class="items-header">Detalle del pedido</div>
              @for (item of order.order_items; track item.product_id) {
                <div class="item-row">
                  <div class="item-main">
                    <span class="item-qty">{{ item.quantity }}x</span>
                    <span class="item-name">{{ item.product_name }}</span>
                    <span class="item-price">{{ formatPrice(item.unit_price * item.quantity, order.currency) }}</span>
                  </div>
                  @if (item.customizations) {
                    <div class="item-customizations">
                      @if (item.customizations.without && item.customizations.without.length > 0) {
                        <span class="custom-tag custom-without">Sin {{ item.customizations.without.join(', ') }}</span>
                      }
                      @if (item.customizations.extras && item.customizations.extras.length > 0) {
                        @for (extra of item.customizations.extras; track extra.name) {
                          <span class="custom-tag custom-extra">+ {{ extra.name }}</span>
                        }
                      }
                      @if (item.customizations.note) {
                        <span class="custom-tag custom-note">{{ item.customizations.note }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="order-footer-info">
            @if (!order.order_ref && order.tpv_order_id) {
              <span class="order-id-small">#{{ order.tpv_order_id.substring(0, 8) }}</span>
            }
            @if (order.estimated_minutes && isActiveOrder(order.status)) {
              <span class="estimated-time">~{{ order.estimated_minutes }} min</span>
            }
            @if (isActiveOrder(order.status)) {
              <span class="live-indicator"></span>
            }
          </div>

          @if (!isActiveOrder(order.status)) {
            <button class="delete-btn" (click)="deleteOrder($event, order.id)" title="Eliminar del historial">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              </svg>
            </button>
          }
        </div>
      }
    </div>
  }

  } <!-- end orders tab -->

  <!-- ========== RESERVATIONS TAB ========== -->
  @if (activeTab() === 'reservations') {

    @if (loadingReservations()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Cargando reservas...</p>
      </div>
    }

    @if (!loadingReservations() && reservations().length === 0) {
      <div class="empty-state">
        <div class="empty-icon">📅</div>
        <h3>Sin reservas</h3>
        <p>Aun no has realizado ninguna reserva</p>
      </div>
    }

    @if (!loadingReservations() && reservations().length > 0) {
      <div class="orders-list">
        @for (res of reservations(); track res.id) {
          <div class="order-card" [class.order-active]="res.status === 'pending' || res.status === 'confirmed'">
            <div class="order-top">
              <div class="order-business">
                <span class="service-icon">{{ getBusinessTypeIcon(res.business_type) }}</span>
                <div class="business-info">
                  <span class="business-name">{{ res.business_name || 'Negocio' }}</span>
                  <span class="order-date">{{ formatReservationDate(res.reservation_date) }} - {{ res.time_start }}</span>
                </div>
              </div>
              <span class="status-badge" [class]="getReservationStatusClass(res.status)">
                {{ getReservationStatusLabel(res.status) }}
              </span>
            </div>

            <div class="order-details">
              @if (res.party_size) {
                <div class="detail-row">
                  <span class="detail-label">Personas</span>
                  <span class="detail-value">{{ res.party_size }}</span>
                </div>
              }
              <div class="detail-row">
                <span class="detail-label">Nombre</span>
                <span class="detail-value">{{ res.customer_name }}</span>
              </div>
              @if (res.notes) {
                <div class="detail-row">
                  <span class="detail-label">Notas</span>
                  <span class="detail-value">{{ res.notes }}</span>
                </div>
              }
            </div>

            <div class="reservation-actions">
              @if (res.status === 'pending' || res.status === 'confirmed') {
                <button class="cancel-btn" (click)="cancelReservation($event, res.id)">Cancelar reserva</button>
              }
              @if (isTerminalReservation(res.status)) {
                <button class="delete-btn" (click)="deleteReservation($event, res.id)" title="Eliminar del historial">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }

  } <!-- end reservations tab -->

</div>
